import { LoadSegmentsRequest } from '@/models/LoadSegmentsRequest';

import { confugrationApi } from '@/api/configurationApi'
import { segmentsApi } from '@/api/segmentsApi';

export class archivedDocumentService {

    async loadConfigurations(documentId: number) {
        return confugrationApi.getArchivedTranslationConfig(documentId)
    }

    async loadTranslationSegments(request: LoadSegmentsRequest) {
        return segmentsApi.getDocumentSegments(request)
    }
}